import React from 'react';
import styled from 'styled-components';

import { ApiFill } from '#/api/types';
import PaginationNoContentOverWarning from '#/components/basic/pagination/PaginationNoContentOverWarning';
import PaginationNumbers from '#/components/basic/pagination/PaginationNumbers';
import { PAGINATION_PAGES_LIMIT } from '#/config/constants';
import { redirectTo } from '#/lib/redirect';
import { useSelector } from '#/reduxState/store';

import MyTradesTable from './MyTradesTable';
import { useTradesTableRows } from './useTradesTableRows';

const PaginationWrap = styled.div`
  text-align: center;
  padding: 20px 0;
`;

type Props = {
  page: number;
  pageLimit: number;
  fills: ApiFill[];
  isLoading: boolean;
  isPreviousData: boolean;
  totalCount?: number;
  onChangePage: (page: number) => void;
  vaultManagerWallet?: string;
  /** Merge fills of the same order into a single row (within the current page) */
  aggregateByOrder?: boolean;
  /** Display "Order ID" column */
  showOrderId?: boolean;
};

export default function MyTradeHistoryMultiMarket({
  page,
  totalCount,
  pageLimit,
  isLoading,
  isPreviousData,
  fills,
  onChangePage,
  vaultManagerWallet,
  aggregateByOrder = false,
  showOrderId = false,
}: Props) {
  const isMobile = useSelector(state => state.screen.isMobile);

  // TODO: TradeHistory Appear row animation is broken, disabled for now
  const appearAnimationEnabled = false;
  // const appearAnimationEnabledRef = useRef(false);
  // const [appearAnimationEnabled, setAppearAnimationEnabled] = useState(false);
  // useEffect(() => {
  //   // appearAnimationEnabledRef.current = false;
  //   const timeout = setTimeout(() => {
  //     // appearAnimationEnabledRef.current = true;
  //     setAppearAnimationEnabled(true);
  //   }, 1000);
  //   return () => {
  //     clearTimeout(timeout);
  //   };
  // }, [page]);

  const { trades, onToggleAggregation } = useTradesTableRows(
    fills,
    aggregateByOrder
  );

  return (
    <>
      {page > PAGINATION_PAGES_LIMIT ? (
        <PaginationNoContentOverWarning />
      ) : (
        <MyTradesTable
          loading={isLoading || isPreviousData}
          trades={trades}
          appearAnimationEnabled={appearAnimationEnabled}
          onSelectOrder={
            vaultManagerWallet
              ? undefined
              : isMobile
              ? (orderId, fillId) => {
                  redirectTo(`/wallet/history/trades/${orderId}/${fillId}`);
                }
              : undefined
          }
          vaultManagerWallet={vaultManagerWallet}
          showOrderId={showOrderId}
          onToggleAggregation={onToggleAggregation}
        />
      )}
      {!isLoading && (
        <PaginationWrap>
          <PaginationNumbers
            onSelect={onChangePage}
            selected={page}
            totalCount={totalCount}
            pageLimit={pageLimit}
          />
        </PaginationWrap>
      )}
    </>
  );
}
